<template>
  <van-sticky>
    <div v-if="hasSearch" class="search-bar">
      <van-search v-model.trim="queryForm.keyword" clearable shape="round" placeholder="搜索人才" @clear="handleCancle" @search="handleSearch">
        <base-icon slot="left-icon" name="search_icon" class="icon" />
      </van-search>
      <div class="search-btn" @click="handleSearch">
        搜索
      </div>
    </div>
    <div class="filter-bar">
      <div :class="['filter-item', { active: hasCate }]" @click="openConditionPanel('cate')">
        <span class="text">
          <div class="van-ellipsis">{{ filtJob }}</div>
        </span>
      </div>
      <div :class="['filter-item', { active: hasRegion }]" @click="openConditionPanel('region')">
        <span class="text">
          <div class="van-ellipsis">{{ filtRegion }}</div>
        </span>
      </div>
    </div>
    <van-popup v-model="isShowConditionPopup" position="bottom" @closed="handleClosed">
      <div class="condition-popup">
        <div class="header">
          <base-icon class="close-icon" name="ic_popup_close" @click.native="handleClosed" />
          <div class="title">
            {{ popupTitle }}
          </div>
        </div>
        <div id="body" class="body">
          <div v-show="currentPanel === 'region'" :class="[substationOpened ? 'cate-panel' : 'region-panel']">
            <base-condition-single v-model="queryForm.region" title="工作区域" show-near :show-unlimited="false" :options="regionOptions" />
          </div>
          <div v-show="currentPanel=== 'range'" class="salary-panel">
            <base-condition-single v-model="queryForm.range" title="直线距离" :options="rangeOptions" />
          </div>
          <div v-show="currentPanel === 'cate'" class="cate-panel">
            <ul class="menu main-menu">
              <li :class="['menu-item', 'menu-item-main', { active: !queryForm.subarea_id }]" @click="handleClickMainMenu(null)">
                <span class="menu-name">全部</span>
              </li>
              <li v-for="item in subareaList" :key="item.id" :class="['menu-item', 'menu-item-main', { active: item.id === queryForm.subarea_id * 1}]" @click="handleClickMainMenu(item)">
                <span class="menu-name" :class="{'menu-active': currentItems.find(i=>i.subarea_id == item.id * 1)}">{{ item.name }}</span>
              </li>
            </ul>
            <ul class="menu sub-menu">
              <li :class="['menu-item', 'menu-item-sub', { active: currentItems.find(i=> (i.subarea_id == queryForm.subarea_id) && !i.id ) }]" @click="handleClickSubMenuAll()">
                <span class="menu-name">全部</span>
                <base-icon class="icon" name="icon_checked" />
              </li>
              <li v-for="item in categoryList" :key="item.id" :class="['menu-item', 'menu-item-sub', { active: currentItems.find(i=>i.id == item.id * 1)}]" @click="handleClickSubMenu(item)">
                <span class="menu-name">{{ item.name }}</span>
                <base-icon class="icon" name="icon_checked" />
              </li>
            </ul>
          </div>

          <div v-show="currentPanel === 'salary' || currentPanel === 'salaryModel'" class="salary-panel">
            <base-condition-single v-model="queryForm.salaryModel" title="结算方式" :options="salaryModelOptions" />
          </div>
        </div>
        <div class="footer">
          <button class="btn btn-reset" @click="handleReset">
            重置
          </button>
          <button class="btn btn-confirm" @click="handleConfirm">
            确定
          </button>
        </div>
      </div>
    </van-popup>
  </van-sticky>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { mapGetters } from 'vuex';
import { objToArr, isDef, isArray } from '@/utils/common';

export default {
  name: 'AppServiceFilterBar',
  props: {
    hasBack: {
      type: Boolean,
      default: false,
    },
    type: String,
    hasSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowConditionPopup: false,
      currentPanel: '',
      queryForm: {
        keyword: '',
        welfare: [],
      },
      queryParams: {},
      nowTradingOptions: [],
      // 项目筛选文案
      categoryList: [],
      subareaList: [],
      tradingOptions: [],
      currentItems: [{ id: null, name: '', subarea_id: null }],
      paramsCurItems: [{ id: null, name: '', subarea_id: null }],
    };
  },
  computed: {
    ...mapGetters(['dict', 'substation', 'substationOpened']),
    popupTitle() {
      let obj = {
        region: '工作区域',
        cate: '服务分类',
        salary: '薪资范围',
        range: '直线距离',
        salaryModel: '结算方式',
        more: '筛选',
      };
      return obj[this.currentPanel];
    },
    siteList() {
      return [{ id: -1, is_global: true, name: '全部' }, ...this.dict.SITE_LIST] || [];
    },
    regionList() {
      const list = this.dict.REGION_LIST_V2.filter(item => item.site_id == this.queryForm.site_id);
      return list || [];
    },
    // 福利待遇
    welfareOptions() {
      return objToArr(this.dict.COMPANY_WELFARE_LIST);
    },
    // 地点
    regionOptions() {
      let regionList = this.dict.ODD_SERVICE_REGION_LIST || [];
      return regionList.map(item => {
        return {
          id: item.value,
          name: item.label,
        };
      });
    },
    // 工作年限
    workYearsOptions() {
      return [
        { name: '1年', id: 1 },
        { name: '2年', id: 2 },
        { name: '3年', id: 3 },
        { name: '3-5年', id: 5 },
        { name: '5-10年', id: 10 },
        { name: '10年以上', id: 100 },
      ];
    },
    // 学历要求
    eduOptions() {
      return [
        { name: '高中以下', id: 1 },
        { name: '高中', id: 2 },
        { name: '中专/技校', id: 3 },
        { name: '大专', id: 4 },
        { name: '本科', id: 5 },
        { name: '硕士', id: 6 },
        { name: '博士', id: 7 },
        { name: 'MBA/EMBA', id: 8 },
      ];
    },
    // 企业标签
    labelOptions() {
      return objToArr(this.dict.COMPANY_LABEL_LIST);
    },
    // 工作性质选项
    workTypeOptions() {
      return [
        { name: '全职', id: 1 },
        { name: '兼职', id: 2 },
      ];
    },
    // 结薪方式筛选项
    salaryModelOptions() {
      return [
        { id: 'day', name: '日结' },
        { id: 'week', name: '周结' },
        { id: 'month', name: '月结' },
        { id: 'endAll', name: '完工结算' },
      ];
    },
    rangeOptions() {
      return [
        { id: '1000', name: '1公里内' },
        { id: '3000', name: '3公里内' },
        { id: '5000', name: '5公里内' },
        { id: '7000', name: '7公里内' },
        { id: '10000', name: '10公里内' },
      ]
    },
    // 薪资筛选项
    salaryOptions() {
      return [
        { name: '1千以下', id: 1, salaryFrom: 0, salaryTo: 1000 },
        { name: '1千-2千', id: 2, salaryFrom: 1000, salaryTo: 2000 },
        { name: '2千-3千', id: 3, salaryFrom: 2000, salaryTo: 3000 },
        { name: '3千-5千', id: 4, salaryFrom: 3000, salaryTo: 5000 },
        { name: '5千-8千', id: 5, salaryFrom: 5000, salaryTo: 8000 },
        { name: '8千-1.2万', id: 6, salaryFrom: 8000, salaryTo: 12000 },
        { name: '1.2万-2万', id: 7, salaryFrom: 12000, salaryTo: 20000 },
        { name: '2万以上', id: 8, salaryFrom: 20000, salaryTo: 0 },
        { name: '面议', id: 9 },
      ];
    },
    filtRegion() {
      if (this.substationOpened) {
        let text = '工作区域';

        if (this.queryParams.site_id && this.siteList.length) {
          let item = this.siteList.find(item => item.id === this.queryParams.site_id * 1);
          text = item.name;
        }
        if (this.queryParams.region && this.regionList.length) {
          let item = this.regionOptions.find(item => item.id === this.queryParams.region * 1);
          text = item.name;
        }
        return text;
      } else {
        if (this.queryParams.region * 1 === 0) {
          return '附近';
        } else if (this.queryParams.region) {
          const region = this.regionOptions.find(item => item.id === this.queryParams.region * 1);
          return region.name;
        } else {
          return '工作区域';
        }
      }
    },
    filtJob() {
      if (this.paramsCurItems.length) {
        let menu = this.paramsCurItems.filter(i => i.name).map(i => i.name)
        return menu && menu.length ? menu.join('，') : '人才服务分类'
      } else {
        return '人才服务分类'
      }
    },
    filtRange() {
      const range = this.rangeOptions.find(item => item.id === this.queryParams.range)
      return range ? range.name : '直线距离'
    },
    hasRange() {
      return Boolean(isDef(this.queryParams.range));
    },
    hasRegion() {
      return Boolean(isDef(this.queryParams.site_id) || isDef(this.queryParams.region));
    },
    hasCate() {
      const menu = this.paramsCurItems.filter(i => i.name)
      return Boolean(menu.length)
      // return Boolean(isDef(this.queryParams.subarea_id));
    },
    hasSalary() {
      return Boolean(isDef(this.queryParams.salaryModel));
    },
    hasMore() {
      return Boolean(
        isDef(this.queryParams.trading_area_id) ||
        isDef(this.queryParams.work_years) ||
        isDef(this.queryParams.edu) ||
        isDef(this.queryParams.welfare) ||
        isDef(this.queryParams.label)
      );
    },
  },
  watch: {
    value: {
      handler() {
        this.queryForm = cloneDeep(this.$route.query);
        this.queryParams = cloneDeep(this.$route.query);
      },
      deep: true,
      immediate: true,
    },
    // substation: {
    //   handler(val) {
    //     this.queryForm = {};
    //     this.queryParams = {};
    //     if (this.type !== 'map') {
    //       this.$set(this.queryForm, 'site_id', val ? val.id : undefined);
    //       this.$set(this.queryParams, 'site_id', val ? val.id : undefined);
    //     }
    //     this.handleConfirm();
    //   },
    // },
    currentItems: {
      // 显示勾选全部
      handler(oldVal, newVal) {
        if (newVal.length == 0) {
          this.currentItems = [{ id: null, name: '', subarea_id: null }]
        }
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    getContainer() {
      return document.querySelector('#body');
    },
    handleSwitch() {
      this.type === 'list' && this.$router.push({ path: '/job/map' })
      this.type === 'map' && this.$router.push({ path: '/job' })
    },
    handleBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    },
    openConditionPanel(type) {
      this.currentPanel = type;
      this.isShowConditionPopup = true;
    },
    handleClosed() {
      this.queryForm = cloneDeep(this.queryParams);
      this.currentItems = cloneDeep(this.paramsCurItems)
      this.queryForm.subarea_id = this.paramsCurItems.length ? this.paramsCurItems[0].subarea_id : null
      const idx = this.subareaList.findIndex(item => item.id === this.queryForm.subarea_id * 1);
      if (idx === -1) {
        this.$set(this, 'categoryList', [])
      } else {
        const categoryList = this.subareaList[idx].infoCategory;
        this.$set(this, 'categoryList', categoryList)
      }
      this.isShowConditionPopup = false;
    },
    /**
     * 处理搜索
     */
    handleSearch() {
      // 占友伟新规则：有关键字时点击搜索按钮则清空其他条件
      if (this.queryForm.keyword) {
        let q = JSON.parse(JSON.stringify({ keyword: this.queryForm.keyword }))
        this.$set(this, 'queryForm', q);
        this.$set(this, 'queryParams', q);
      }
      this.handleConfirm();
    },
    handleCancle() {
      this.queryForm = {}
      this.queryParams = {}
      this.handleConfirm();
    },
    async fetchData() {
      try {
        const subarea = await this.$api.getOddSubareaList();
        const query = this.$route.query
        this.$set(this, 'subareaList', subarea);
        if (query.subarea_id) {
          const idx = this.subareaList.findIndex(item => item.id === this.queryForm.subarea_id * 1);
          const categoryList = this.subareaList[idx].infoCategory;
          this.categoryList = categoryList
        }
        if (query.subarea_id && !query.jobCategory) {
          const name = this.subareaList.find(i => i.id === query.subarea_id * 1).name || ''
          const curItems = [{ id: null, name: name, subarea_id: query.subarea_id * 1 }]
          this.$set(this, 'paramsCurItems', curItems)
          this.$set(this, 'currentItems', curItems)
        }
        if (query.subarea_id && query.jobCategory) {
          const category = this.subareaList.find(i => i.id === query.subarea_id * 1)
          const name = category.infoCategory.find(i => i.id === query.jobCategory * 1).name || ''
          const curItems = [{ id: query.jobCategory * 1, name: name, subarea_id: query.subarea_id * 1 }]
          this.$set(this, 'paramsCurItems', curItems)
          this.$set(this, 'currentItems', curItems)
        }
        this.handleConfirm();
        if (this.type === 'map') {
          return
        }
      } catch (err) {
        this.$toast(err.message);
      }
    },
    handleClickMainSite(menu) {
      this.$set(this.queryForm, 'site_id', menu ? menu.id : undefined);
      this.$set(this.queryForm, 'region', undefined);
    },
    handleClickSubSite(menu) {
      this.$set(this.queryForm, 'region', menu ? menu.value : undefined);
    },
    handleClickMainMenu(menu) {
      this.queryForm.subarea_name = menu ? menu.name : ''; // 用于微信分享时展示名称
      this.$set(this.queryForm, 'subarea_id', menu ? menu.id : undefined);
      this.$set(this.queryForm, 'jobCategory', undefined);
      this.categoryList = menu ? menu.infoCategory : [];
    },
    handleClickSubMenu(menu) {
      // 选中二级分类 清空一级分类全部选项
      const emptyIndex = this.currentItems.findIndex(i => !i.id && !i.name && !i.subarea_id)
      if (emptyIndex !== -1) {
        this.currentItems.splice(emptyIndex, 1)
      }
      // 选中二级分类全部 清空其他二级分类选中
      const categoryIndex = this.currentItems.findIndex(i => i.subarea_id == menu.subarea_id && !i.id)
      if (categoryIndex !== -1) {
        this.currentItems.splice(categoryIndex, 1)
      }
      const index = this.currentItems.findIndex(i => i.id == menu.id)
      if (index !== -1) {
        this.currentItems.splice(index, 1)
      } else if (this.currentItems.length >= 3) {
        return this.$toast({ message: '最多可选择三个分类', getContainer: '#body' });
      } else {
        this.currentItems.push(menu)
      }
      this.queryForm.category_name = menu ? menu.name : ''; // 用于微信分享时展示名称
      this.$set(this.queryForm, 'jobCategory', menu ? menu.id : undefined);
    },
    handleClickSubMenuAll() {
      // 选择全部 重置选中项
      const index = this.currentItems.findIndex(i => (i.subarea_id == this.queryForm.subarea_id) && !i.id)
      if (index !== -1) {
        this.currentItems.splice(index, 1)
      } else {
        // 选择一级分类全部 清空所有选择数据
        if (!this.queryForm.subarea_id) {
          this.currentItems = [{ id: null, name: '', subarea_id: null }]
          return
        }
        // 一级分类全部取消选择
        const emptyIndex = this.currentItems.findIndex(i => !i.id && !i.name && !i.subarea_id)
        if (emptyIndex !== -1 && this.currentItems.length == 1) {
          this.currentItems.splice(emptyIndex, 1)
          this.currentItems.push({ id: null, subarea_id: this.queryForm.subarea_id, name: this.queryForm.subarea_name })
        }
        let formartItems = this.currentItems.filter(i => i.subarea_id * 1 !== this.queryForm.subarea_id * 1)
        if (formartItems.length < 3) {
          formartItems.push({ subarea_id: this.queryForm.subarea_id, id: null, name: this.queryForm.subarea_name })
          this.currentItems = formartItems
        } else {
          this.$toast({ message: '最多可选择三个分类', getContainer: '#body' });
        }
      }
    },
    /**
     * 点击重置
     */
    handleReset() {
      switch (this.currentPanel) {
        case 'region':
          this.$set(this.queryForm, 'site_id', undefined);
          this.$set(this.queryForm, 'region', undefined);
          break;
        case 'cate':
          this.$set(this.queryForm, 'subarea_id', undefined);
          this.$set(this.queryForm, 'jobCategory', undefined);
          this.$set(this, 'categoryList', [])
          this.$set(this, 'currentItems', [{ id: null, name: '', subarea_id: null }])
          break;
        case 'range':
          this.$set(this.queryForm, 'range', undefined);
          break;
        case 'salary':
          this.$set(this.queryForm, 'salary', undefined);
          break;
        case 'salaryModel':
          this.$set(this.queryForm, 'salaryModel', undefined);
          break;
        case 'more':
          this.$set(this.queryForm, 'welfare', undefined); // 福利待遇
          this.$set(this.queryForm, 'work_years', undefined); // 工作年限
          this.$set(this.queryForm, 'edu', undefined); // 学历要求
          this.$set(this.queryForm, 'label', undefined); // 企业标签
          this.$set(this.queryForm, 'jobType', undefined); // 工作性质
          break;
      }
    },
    /**
     * 点击确定
     */
    handleConfirm() {
      // 切换工作性质
      let queryParams = JSON.parse(
        JSON.stringify(this.queryForm, (key, value) => {
          if (isDef(value)) {
            return value;
          }
        })
      );
      this.paramsCurItems = cloneDeep(this.currentItems)
      let categoryIds = this.paramsCurItems.filter(i => i.id).map(i => i.id)
      const allSubareaIds = this.paramsCurItems.filter(i => i.subarea_id && !i.id).map(i => i.subarea_id)
      if (allSubareaIds.length) {
        this.subareaList.forEach(sub => {
          if (allSubareaIds.includes(sub.id)) {
            categoryIds = categoryIds.concat(sub.infoCategory.map(i => i.id))
          }
        })
      }
      queryParams.subarea_ids = this.paramsCurItems.length ? this.paramsCurItems.map(i => i.subarea_id).join(',') : ''
      queryParams.category_ids = categoryIds.length ? categoryIds.join(',') : ''
      queryParams.site_id = queryParams.site_id === -1 ? null : queryParams.site_id
      queryParams.category_id = queryParams.jobCategory
      delete queryParams.subarea_id
      this.queryParams = cloneDeep(queryParams);
      this.$emit('input', Object.assign({}, this.queryParams));
      this.$emit('update', Object.assign({}, this.queryParams))
      this.isShowConditionPopup = false;
      this.$set(this, 'tradingOptions', this.queryParams.site_id === -1 ? this.nowTradingOptions : this.nowTradingOptions.filter(i => i.site_id === this.queryParams.site_id));
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-cell__value {
  padding-left: 4px;
}
/deep/ .van-cell {
  padding: 6px 8px 5px 0 !important;
}
.search-bar {
  display: flex;
  flex-direction: row;
  padding-right: 20px;
  background: #fff;
  align-items: center;
  .icon {
    height: 36px;
    width: 36px;
  }
  .van-icon-clear {
    padding-right: 30px !important;
  }
  .van-search {
    display: flex;
    flex: 1;
    padding-right: 10px;
  }
  .van-search__content {
    height: 72px;
    .van-cell {
      display: flex;
      align-items: center;
      padding-right: 10px;
    }
  }
  /deep/ .van-field__left-icon {
    height: 36px;
    width: 36px;
  }
  // /deep/ .van-field__left-icon {
  //   display: flex;
  //   align-items: center;
  // }
  // .van-search {
  //   padding: 16px 5px 15px 10px;
  //   flex: 1;
  //   font-size: 30px;
  //   .van-search__content {
  //     height: 36px;
  //   }
  // }
  .search-btn {
    font-size: 28px;
    border-radius: 60px;
    background: linear-gradient(135deg, #ff8a3f 0%, #fd5c60 100%);
    color: #fff;
    height: 72px;
    width: 120px;
  }
}
.condition-popup {
  height: 70vh;
  display: flex;
  flex-direction: column;

  .header {
    position: relative;
    padding: 26px 30px;

    .close-icon {
      position: absolute;
      right: 30px;
      top: 50%;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
    }

    .title {
      text-align: center;
      font-size: 36px;
      font-weight: 500;
      color: #333;
    }
  }
  .body {
    flex: 1;
    overflow: hidden;
    .region-panel,
    .salary-panel,
    .more-panel {
      height: 100%;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    .cate-panel {
      display: flex;
      height: 100%;
      background: #fff;
      overflow: hidden;
      .menu {
        list-style: none;
        margin: 0;
        padding: 0;
        height: 100%;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        .menu-item {
          display: flex;
          align-items: center;
          height: 110px;
          padding: 0 40px;
          .menu-name {
            flex: 1;
            width: 0;
            color: #666;
            font-size: 32px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            &.menu-active {
              color: #e84c3d;
            }
          }

          .icon {
            display: none;
            width: 36px;
            height: 36px;
          }
        }
      }

      .main-menu {
        width: 300px;
        background-color: #f7f7f7;
        .menu-item-main {
          &.active {
            background: #fff;
          }
        }
      }
      .sub-menu {
        flex: 1;
        background: #fff;
        .menu-item-sub {
          &.active {
            font-weight: 700;
            .menu-name {
              color: #e84c3d;
            }

            .icon {
              display: block;
            }
          }
        }
      }
    }
  }

  .footer {
    display: flex;
    padding: 20px 40px;
    .btn {
      height: 90px;
      line-height: 90px;
      font-size: 32px;
      font-weight: 500;
      border-radius: 16px;
      & + .btn {
        margin-left: 20px;
      }
      &-reset {
        width: 220px;
        background: #f1f2f6;
        color: #666666;
      }
      &-confirm {
        flex: 1;
        background: linear-gradient(130deg, #fc6242 0%, #f0403c 100%);
        color: #fff;
      }
    }
  }
}
.filter-bar {
  position: relative;
  border-top: 1px solid #f1f2f6d2;
  background-color: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f2f6d2;
  justify-content: space-around;
  padding: 0 20px;
  .filter-item {
    width: 38vw;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90px;
    color: #4d4d4d;
    min-width: 0;
    &.active {
      color: #e84c3d;
      .text:after {
        border-color: transparent transparent #e84c3d #e84c3d;
      }
    }
    .text {
      position: relative;
      font-size: 28px;
      padding: 0 16px;
      max-width: 100%;

      &:after {
        position: absolute;
        top: 50%;
        right: -6px;
        margin-top: -10px;
        border-color: transparent transparent #b2b2b2 #b2b2b2;
        border-style: solid;
        border-width: 6px;
        transform: rotate(-45deg);
        opacity: 0.8;
        content: "";
      }
    }
  }
}
.search-bar {
  .map-icon {
    display: flex;
    flex-direction: column;
    color: #262626;
    align-items: center;
    font-size: 20px;
    padding-left: 30px;
    .icon {
      height: 36px;
      width: 36px;
    }
  }
}
</style>
